import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { articles } from '@/lib/articles';
import { breakpoints } from '@/layouts/breakpoints'

import {
  Clock,
  Calendar
} from 'lucide-react';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const StyledBlogs = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 20px 0;
  .text{
    padding-bottom: 40px;

    p, h3{
      text-align: center;
    }
    p{
      font-size: 12px;
      padding-top: 6px;
      color: var(--grey);

      @media (max-width: ${breakpoints.medium}) {
        width: 80%;
        margin: 0 auto;
      }
    }
  }
  h3{
    font-size: 32px;

    @media (max-width: ${breakpoints.medium}) {
      font-size: 24px;
    }
  }

`;

const MarqueeWrapper = styled.div`
  display: flex;
  width: fit-content;
  animation: ${scroll} 89s linear infinite;
  gap: 20px;

  @media (max-width: ${breakpoints.medium}) {
    animation: ${scroll} 140s linear infinite;
  }

  &:hover {
    animation-play-state: paused;
  }
`;

const Article = styled.div`
  max-width: 500px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(128, 128, 128, 0.3);
  background: white;
  flex-shrink: 0;
  overflow: hidden;


  @media (max-width: ${breakpoints.medium}) {
    width: 300px;
  }


  .content {
    width: 80%;
    padding-top: 20px;
    padding-left: 20px;
  }

  p {
    color: var(--grey);
    line-height: 1.4;
    padding: 10px 0;
    font-size: 11px;
  }

  h4 {
    text-transform: uppercase;
  }

  .image {
    position: relative;
    width: 100%;
    height: 250px;

    @media (max-width: ${breakpoints.medium}) {
      height: 150px;
    }
    .date {
      position: absolute;
      top: 0;
      right: 0;
      padding: 5px 10px;
      color: var(--white);
      z-index: 2;
      font-size: 10px;
      display: flex;
      align-items: center;
      font-family: sans-serif;
      font-weight: bold;

      svg {
        width: 10px;
        height: 10px;
        padding-right: 5px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .action {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 9px;
    padding: 20px;
    color: #666;

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;

      svg {
        color: #666;
        width: 12px;
        height: 12px;
      }
    }

    button {
      padding: 5px 20px;
      background: #000;
      color: white;
      border: none;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.3s ease;

      &:hover {
        background: #333;
      }
    }
  }
`;
const Blogs = ({title="Resources To Get Started", text="Practical guides and essentials to help you get up and running quickly. "}) => {
  const navigate = useNavigate()
  const duplicatedArticles = [...articles, ...articles];

  const formatDisplayDate = (iso: string) => {
    const d = new Date(`${iso}T00:00:00Z`);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
  };

  return (
    <StyledBlogs>
      <div className="text">
        <h3 className="serif"> {title}</h3>
        <p> {text}</p>
      </div>

      <MarqueeWrapper>
        {duplicatedArticles.map((article,i) => (
          <Article key={article.id+i}>
            <div className="image">
              <div className="date">
                <Calendar /> {formatDisplayDate(article.date)}
              </div>
              <img src={article.img} alt={article.title} width="500" height="250" loading="lazy" />
            </div>
            <div className="content">
              <h4>{article.title}</h4>
              <p>{article.desc}</p>
            </div>
            <div className="action">
              <span>
                <Clock /> {article.readTime}
              </span>
              <button onClick={
                (e) => {
                  const url = `/blog/${article.id}`;
                  if (e.ctrlKey || e.metaKey) {
                    window.open(url, '_blank', 'noopener,noreferrer');
                  } else {
                    navigate(url);
                  }
                }

              }>read</button>
            </div>
          </Article>
        ))}
      </MarqueeWrapper>
    </StyledBlogs>
  );
};

export default Blogs;
